document.addEventListener('DOMContentLoaded', function() {
  const scrollArrow = document.getElementById('scroll-arrow');
  if (scrollArrow) {
    scrollArrow.addEventListener('click', function() {
      // Using requestAnimationFrame for smoother scrolling
      const scrollToBottom = () => {
        // First try to find a section with the custom ID from settings
        let targetElement = document.getElementById(scrollArrow.dataset.targetId);
        
        // If that specific element isn't found, look for any section near the bottom
        if (!targetElement) {
          // Get all sections and find one near the bottom
          const sections = document.querySelectorAll('main > section');
          if (sections.length > 0) {
            // Target one of the last sections (last or second to last)
            const targetIndex = sections.length > 1 ? sections.length - 2 : sections.length - 1;
            targetElement = sections[targetIndex];
          }
        }
        
        // If we found a target, scroll to it
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        } else {
          // As a fallback, scroll to the footer or bottom of page
          const footer = document.querySelector('footer');
          if (footer) {
            footer.scrollIntoView({ behavior: 'smooth' });
          } else {
            window.scrollTo({
              top: document.body.scrollHeight,
              behavior: 'smooth'
            });
          }
        }
      };
      
      requestAnimationFrame(scrollToBottom);
    });
  }
});
